import { create } from "zustand";
import { toast } from "sonner";

interface AutopilotState {
  isAutopilotLoading: boolean;
  error: string | null;
  toggleThreadAutopilot: (
    campaignCreatorId: string,
    autopilot: boolean,
    token: string
  ) => Promise<boolean>;
  reset: () => void;
}

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const useAutopilotStore = create<AutopilotState>((set) => ({
  isAutopilotLoading: false,
  error: null,

  toggleThreadAutopilot: async (
    campaignCreatorId: string,
    autopilot: boolean,
    token: string
  ) => {
    set({ isAutopilotLoading: true, error: null });
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/campaigns/toggleThreadAutopilot`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            campaign_creator_id: campaignCreatorId,
            autopilot,
          }),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        toast.error(data.error);
        throw new Error("Failed to toggle autopilot");
      }

      toast.success(data.message);
      set({ isAutopilotLoading: false });
      return data.success;
    } catch (error) {
      set({ error: (error as Error).message, isAutopilotLoading: false });
      return false;
    }
  },

  reset: () => set({ isAutopilotLoading: false, error: null }),
}));
